export default __webpack_public_path__ + "static/logo-15726d569e7ed560c3f7a4402facd2f2.png";